import { Group, Text, Box } from "@mantine/core";
import vaparLogoOriginal from "../assets/images/vapar-logo-original.svg";

const Logo = ({ showTitle = false, subLabel }) => {
  return (
    <Group gap="xs" wrap="nowrap" align="center">
      <img src={vaparLogoOriginal} alt="VAPAR Logo" width={22} height={22} />
      {showTitle && (
        <Text
          fw={700}
          size="16px"
          ff="var(--font-outfit)"
          style={{ letterSpacing: 0, lineHeight: 1 }}
        >
          VAPAR
        </Text>
      )}
      {showTitle && subLabel && (
        <>
          <Box
            style={{
              width: 1,
              height: 16,
              backgroundColor: "var(--mantine-color-default-border)",
            }}
          />
          <Text
            fw={400}
            size="16px"
            ff="var(--font-outfit)"
            style={{ letterSpacing: 0, lineHeight: 1 }}
          >
            {subLabel}
          </Text>
        </>
      )}
    </Group>
  );
};

export default Logo;
